<template>
  <BOverlay :show="isLoading">
    <BRow>
      <BCol cols="12">
        <BFormGroup :label="label" label-for="ckEditor">
          <CkEditorCustom
            id="ckEditor"
            :hasModules="hasModules"
            :defaultContent="value"
            :placeholder="placeholder"
            @getEditorContent="updateContent"
            @loading="loading"
            @loaded="loaded"
          ></CkEditorCustom>
        </BFormGroup>
      </BCol>
    </BRow>
  </BOverlay>
</template>

<script>
export default {
  emits: ["input"],
  model: {
    event: "input",
    prop: "value",
  },
  props: {
    hasModules: {
      type: Boolean,
      required: false,
      default: true,
    },
    value: {},
    label: {
      type: [String],
      default: "وارد کنید",
    },
    placeholder: {
      type: [String, null],
      default: null,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  methods: {
    updateContent(content) {
      this.$emit("input", content);
    },
    loading() {
      this.isLoading = true;
    },
    loaded() {
      this.isLoading = false;
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    CkEditorCustom,
    BOverlay,
  },
};
import { BOverlay, BRow, BCol, BFormGroup } from "bootstrap-vue";
import CkEditorCustom from "./CkEditorCustom.vue";
</script>
